module.exports = __webpack_public_path__ + "img/maintenance.792297c7.gif";